<script>
import Service from '../../../domain/leiloes/services'
import Vue from 'vue'

export default {
  name: 'importador',
  props: ['dados'],
  data () {
    return {
      finish: false,
      cacheLoader: ''
    }
  },
  computed: {},
  mounted () {
    this.iniciarImportacao()
  },
  destroyed () {
  },
  methods: {
    iniciarImportacao () {
      let leiloes = this.dados.leiloes
      let leilao
      let finish = false
      let pointer = 0
      while (finish === false) {
        if (typeof leiloes[pointer] === 'undefined') {
          finish = true
          this.finalizaImportacao()
          break
        }
        leilao = leiloes[pointer]
        if (leilao.import === 'finish') {
          if (leilao.length === (pointer + 1)) {
            finish = true // Leu o último leilão
            this.finalizaImportacao()
          }
        } else if (leilao.import) { //  === 'wait'
          // Aguardando
          finish = true // Há algo sendo sincronizado
        } else {
          this.importarLeilao(leilao)
          finish = true
        }
        pointer++
      }
    },
    importarLeilao (leilao, noContinue) {
      leilao.import = 'wait'
      leilao.status = 99
      noContinue = typeof noContinue !== 'undefined' && noContinue
      console.log('Importando leilão ' + leilao.dados.titulo)
      let obj = this.dados.leiloes[this.dados.leiloes.indexOf(leilao)]
      Service.importarLeilao(leilao.id, leilao)
        .then((response) => {
          obj.import = 'finish'
          obj.status = response.data.status
          obj.idGerado = response.data.id
          if (obj.lotes && obj.lotes.length > 0) {
            // Importa lotes
            if (!noContinue) {
              this.importarLotes(obj, () => {
                this.finalizaImportacaoLeilao(obj)
                this.iniciarImportacao() // Quando terminar os lotes deste leilão, continuar importação
              })
            }
          }
          console.log(response)
        })
        .catch((error) => {
          obj.import = 'error'
          obj.status = 2
          obj.errors = error.data.errors || error.data.error
          console.log(error)
        })
    },
    importarLotes (leilao, cb) {
      let lote
      let finish = false
      let pointer = 0
      while (finish === false) {
        if (typeof leilao.lotes[pointer] === 'undefined') {
          finish = true
          cb()
        }
        lote = leilao.lotes[pointer]
        console.log(lote)
        if (lote.import === 'finish') {
          if (leilao.lotes.length === (pointer + 1)) {
            finish = true // Leu o último leilão
            cb()
          }
        } else if (lote.import) { //  === 'wait'
          // Continue...
          // finish = true // Há algo sendo sincronizado
          /* console.log(lote.import)
          console.log(lote)
          if (lote.import === 'error') {
            this.importarLote(leilao, lote, cb, false, true)
          } */
        } else {
          this.importarLote(leilao, lote, cb)
          finish = true
        }
        pointer++
      }
    },
    importarLote (leilao, lote, cb, noContinue, renovar) {
      lote.import = 'wait'
      lote.status = 99
      noContinue = typeof noContinue !== 'undefined' && noContinue
      renovar = typeof renovar !== 'undefined' && renovar
      console.log('Importando lote ' + lote.dados.descricao)
      let _continue = () => {
        if (!noContinue) {
          this.importarLotes(leilao, cb)
        }
      }
      if (renovar) {
        lote.status = 0
        lote.importMessage = 'Tentando novamente...'
      }
      Service.importarLote(lote.id, lote, renovar)
        .then((response) => {
          console.log(response)
          lote.import = 'finish'
          lote.status = response.data.status
          _continue()
        })
        .catch((error) => {
          lote.import = 'error'
          lote.status = 2
          lote.errors = error.data ? error.data.errors : 'Cancelado'
          _continue()
          console.log(error)
        })
    },
    finalizaImportacaoLeilao (leilao) {
      leilao = this.dados.leiloes[this.dados.leiloes.indexOf(leilao)]
      console.log('Finalizou importação do leilao ' + leilao.dados.titulo)
      console.log('Renovando cache... ')
      Vue.set(leilao, 'caching', 1)
      // leilao.caching = 1
      this.initCacheLoader()
      Service.renovaCache(leilao.idGerado)
        .then((response) => {
          this.stopCacheLoader()
          leilao.caching = 2
        })
        .catch((response) => {
          this.stopCacheLoader()
          leilao.caching = 3
          window.responseError(response)
          console.log(response)
        })
    },
    finalizaImportacao () {
      console.log('Finalizou')
    },
    initCacheLoader () {
      this._cacheInterval = setInterval(() => {
        console.log(this.cacheLoader)
        this.cacheLoader = this.cacheLoader + '.'
      }, 200)
    },
    stopCacheLoader () {
      clearInterval(this._cacheInterval)
    }
  },
  components: {}
}
</script>

<template>
  <div>
    <div v-for="leilao in dados.leiloes" class="leilao-div">
      <table class="table table-bordered table-condensed table-striped">
        <tbody>
        <tr>
          <td><h4>Importando {{ leilao.dados.titulo }}</h4></td>
          <td width="20%">
            <div v-if="leilao.status == 0">{{ leilao.importMessage ? leilao.importMessage : 'Aguardando'}}</div>
            <div v-if="leilao.status == 1"><span class="text-success">Importado</span></div>
            <div v-if="leilao.status == 2">
              <span class="text-danger">Erro</span> <a @click="importarLeilao(leilao)">Tentar
              novamente</a>
              <br>
              <div class="alert alert-danger small">{{ leilao.errors }}</div>
            </div>
            <div v-if="leilao.status == 99"><i class="fa fa-spinner fa-spin"></i></div>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-bordered table-condensed table-striped">
        <tbody>
        <tr v-for="lote in leilao.lotes">
          <td>{{ lote.dados.descricao }}</td>
          <td width="20%">
            <div v-if="lote.status == 0">{{ lote.importMessage ? lote.importMessage : 'Aguardando'}} <a
              @click="importarLote(leilao, lote, null, true)">Forçar execução</a></div>
            <div v-if="lote.status == 1"><span class="text-success">Importado</span></div>
            <div v-if="lote.status == 2">
              <span class="text-danger">Erro</span> <a @click="importarLote(leilao, lote, null, true)">Tentar
              novamente</a>
              <br>
              <div class="alert alert-danger small">{{ lote.errors }}</div>
            </div>
            <div v-if="lote.status == 99"><i class="fa fa-spinner fa-spin"></i></div>
          </td>
        </tr>
        <tr v-if="leilao.caching">
          <td colspan="2">
            <span v-if="leilao.caching === 1">Gerando cache do leilão e lotes{{cacheLoader}}</span>
            <span v-if="leilao.caching === 2" class="text-success">Cache gerado com sucesso <i class="fa fa-check"></i> </span>
            <span v-if="leilao.caching === 3" class="text-danger">Ocorreu algum problema ao gerar o cache. Gere manualmente após a importação</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Importador.vue?b821b6cc